import { useRef, useEffect } from 'react';

function createRootElement(id) {
  const rootElement = document.createElement('div');
  rootElement.setAttribute('id', id);
  return rootElement;
}
/**
 * @link https://react.dev/reference/react-dom/createPortal
 * @since 2.4.0
 *
 * Returns an existing or newly created Element with the given id, to be used as the container
 * for the createPortal API.
 */
function usePortal(id) {
  const containerRef = useRef(null);
  useEffect(() => {
    const existingParent = document.getElementById(id);
    const parentElement = existingParent || createRootElement(id);
    if (!existingParent) {
      document.body.appendChild(parentElement);
    }
    containerRef.current && parentElement.appendChild(containerRef.current);
    return () => {
      var _a;
      (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.remove();
      // only remove if the element was created with the hook
      if (!existingParent && !parentElement.childElementCount) {
        parentElement.remove();
      }
    };
  }, [id]);
  const getContainerElem = () => {
    if (!containerRef.current) {
      containerRef.current = document.createElement('div');
    }
    return containerRef.current;
  };
  return getContainerElem();
}

export { usePortal };
